export const dateFormats = [
  'dd MMMM yyyy HH:mm',
  'dd.MM.yyyy',
  'dd.MM.yyyy HH:mm',
  'dd MMMM yyyy',
  'dd MMMM yyyy HH:mm',
  'dd MMMM',
];
